export var SET_TODAYS_DATE = 'SET_TODAYS_DATE';
export var setTodaysDate = function setTodaysDate(todaysDate) {
  return {
    type: SET_TODAYS_DATE,
    todaysDate: todaysDate
  };
};